import React from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";

const TestVitrineCard = ({ test, onSelect, isPopular = false, isNew = false }) => {
  const { t } = useTranslation();

  const renderScopes = (scopes) => {
    if (!scopes || scopes.length === 0) return null;
    return (
      <ul className="text-12 mb-0 ps-3">
        {scopes.map((scope) => (
          <li key={scope.id} className="mb-1">
            {scope.name}
            {scope.subScopes && scope.subScopes.length > 0 && (
              <ul className="ps-3">
                {scope.subScopes.map((subScope) => (
                  <li key={subScope.id}>{subScope.name}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Card className="vitrine-card vitrine-card-test h-100 position-relative" onClick={() => onSelect(test)}>
      {/* Popular or New Badge */}
      {isPopular && (
        <div className="position-absolute top-0 end-0 m-3">
          <Badge bg="light" text="danger" className="d-flex align-items-center gap-1">
            <i className="bi bi-heart-fill"></i>
            <span>{t("popular")}</span>
          </Badge>
        </div>
      )}
      {isNew && !isPopular && (
        <div className="position-absolute top-0 end-0 m-3">
          <Badge bg="light" text="success" className="d-flex align-items-center gap-1">
            <i className="bi bi-star-fill"></i>
            <span>{t("newTest")}</span>
          </Badge>
        </div>
      )}

      <Card.Body className="d-flex flex-column p-4">
        {/* Title */}
        <div className="mb-3">
          <h5 className="fw-bold mb-1">{test.name}</h5>
          <p className="text-muted small mb-0">{test.description}</p>
        </div>

        {/* Meta Info */}
        <div className="d-flex align-items-center gap-3 mb-3">
          {test.questionNumber && (
            <div className="d-flex align-items-center gap-1">
              <i className="bi bi-file-text"></i>
              <span className="text-13">
                {test.questionNumber} {t("questions")}
              </span>
            </div>
          )}
          {test.duration && (
            <div className="d-flex align-items-center gap-1">
              <i className="bi bi-clock"></i>
              <span className="text-13">
                {Math.round(test.duration / 60)} {t("min")}
              </span>
            </div>
          )}
        </div>

        {/* Scopes Content */}
        <div className="vitrine-card-info flex-grow-1">
          <PerfectScrollbar options={{ suppressScrollX: true }}>
            {test.scopes && test.scopes.length > 0 && (
              <div>
                <h6 className="text-success fw-semibold mb-2 text-14">{t("scopes")}</h6>
                {renderScopes(test.scopes)}
              </div>
            )}
          </PerfectScrollbar>
        </div>

        {/* Footer with Details Button */}
        <div className="mt-auto pt-3 border-top">
          <button className="btn btn-outline-dark w-100 rounded-pill">{t("details")}</button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TestVitrineCard;
